module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_41.14b0c9df.png";